import ProgressBar from './ProgressBar';
import { StarProgressBarContainer } from './ProgressBar.styles';

interface StarProgressBarProps {
  rating: number;
  now: number;
  label: React.ReactNode;
}

const StarProgressBar = ({ now, rating, label }: StarProgressBarProps) => {
  return (
    <StarProgressBarContainer
      data-testid="star-progress-bar"
      data-rating={rating}
    >
      {label}
      <ProgressBar now={now} color="#FFC454" />
    </StarProgressBarContainer>
  );
};

export default StarProgressBar;
